module.exports = __webpack_public_path__ + "img/microcapsearch.db3d6a36.png";